import Prism from "prismjs";

import * as React from "react";
import CopyButton from "./CopyButton";

export function Code(props) {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref.current) {
            Prism.highlightElement(ref.current, false);
        }
    }, [props.children]);

    return (
        <div className="code" aria-live="polite">
            <pre
                ref={ref}
                className={`language-${props["data-language"]} ${props.fullHeight ? "tall" : ""}`}
            >
                {props.children}
            </pre>
            {props.copy ? <div className="copy"><CopyButton text={props.children}/></div> : null}
            <style jsx>
                {`
          .code {
            position: relative;
            max-width: 100%;
            overflow: auto;
            ${props.fullHeight ? "height: 100%" : ""}
            ${props.noOverflow ? "overflow: visible" : ""}
          }
          .tall {
            height: 100%;
          }
          .copy {
            color: var(--text);
            display: flex;
            align-content: center;
            justify-content: center;
            border-radius: 0 var(--border-radius) var(--border-radius) 0;
            position: absolute;
            right: 1px;
            top: 1px;
            bottom: 1px;
            padding-right: 0.75rem;
          }
          /* Override Prism styles */
          .code :global(pre[class*='language-']) {
            text-shadow: none;
            border-radius: var(--border-radius);
            ${props.copy ? "width: calc(100%); padding-right: 3.4rem;" : ""}
          }
          ${props.margin === "0" ? `.code pre {
            margin-bottom: 0px !important;
          }` : ""}
        `}
            </style>
        </div>
    );
}
